import React, { useEffect, useRef, useState } from 'react';

const WhoWeWorkWith = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.4 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative min-h-screen flex items-center justify-center bg-black text-white py-20 px-6 md:px-12 overflow-hidden">

      {/* Background Image */}
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.pexels.com/photos/28428592/pexels-photo-28428592.jpeg"
          alt="Abstract geometric pattern"
          className="w-full h-full object-cover" />

      </div>

      <div className="container mx-auto max-w-4xl relative z-10">
        <h2
          className="text-5xl md:text-7xl lg:text-8xl font-bold mb-8 tracking-tight"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 1s ease-out 0.2s, transform 1s ease-out 0.2s'
          }}>

          Built for real organisations
        </h2>
        <p
          className="md:text-2xl lg:text-3xl !font-light !text-4xl text-gray-300"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 1s ease-out 0.5s, transform 1s ease-out 0.5s'
          }}>We work with organisations that need AI to function in production - across industry, public sector, and mission-driven work.


        </p>
      </div>
    </section>);

};

export default WhoWeWorkWith;